import { render, staticRenderFns } from "./SostieniInserimentoDati.vue?vue&type=template&id=09fa62c7&scoped=true"
import script from "./SostieniInserimentoDati.vue?vue&type=script&lang=js"
export * from "./SostieniInserimentoDati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fa62c7",
  null
  
)

export default component.exports